export const environment = {
  production: true,
  url: '/api',
  clientIdBase64: 'Z2F0ZXdheTo='
};
